import { AlertTriangle, FileQuestion, MessagesSquare, CheckCircle } from 'lucide-react';
import AnimateIn from './AnimateIn';

const ICON_SIZE = 22;

const problems = [
  {
    icon: AlertTriangle,
    color: '#D97706',
    title: 'Changing regulations',
    desc: 'Landlords face ever-changing rules, document deadlines, and compliance risks that are hard to track alone.',
  },
  {
    icon: FileQuestion,
    color: '#DC2626',
    title: 'Unknown rights',
    desc: "Tenants often don't know what applies to them, what documents to keep, or what to do when something goes wrong.",
  },
  {
    icon: MessagesSquare,
    color: '#64748B',
    title: 'Scattered evidence',
    desc: 'Records, communication, and evidence are spread across emails, photos, texts, and paperwork.',
  },
  {
    icon: CheckCircle,
    color: '#27C281',
    title: 'One clear place',
    desc: 'ActCheck brings everything together in one mobile app so you always know where you stand.',
    highlight: true,
  },
];

export default function ProblemSection() {
  return (
    <section data-testid="problem-section" className="py-20 sm:py-28 bg-mist">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateIn>
          <div className="text-center mb-14">
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-ink mb-4">
              Tenancy management shouldn't feel this overwhelming
            </h2>
            <p className="text-slate-text font-body text-lg max-w-2xl mx-auto">
              Whether you're a landlord or tenant, keeping on top of compliance, documents, and deadlines is harder than it should be.
            </p>
          </div>
        </AnimateIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {problems.map((item, i) => (
            <AnimateIn key={item.title} delay={i * 100}>
              <div
                data-testid={`problem-card-${i}`}
                className={`rounded-2xl p-6 h-full transition-all duration-300 hover:-translate-y-1 ${
                  item.highlight
                    ? 'bg-navy text-white shadow-xl shadow-navy/15'
                    : 'bg-white shadow-sm hover:shadow-md border border-gray-100'
                }`}
              >
                <div
                  className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${
                    item.highlight ? 'bg-compliance-green/20' : 'bg-mist'
                  }`}
                >
                  <item.icon size={ICON_SIZE} style={{ color: item.highlight ? '#49D3A2' : item.color }} />
                </div>
                <h3 className={`font-heading font-bold text-lg mb-2 ${item.highlight ? 'text-white' : 'text-ink'}`}>
                  {item.title}
                </h3>
                <p className={`font-body text-sm leading-relaxed ${item.highlight ? 'text-white/75' : 'text-slate-text'}`}>
                  {item.desc}
                </p>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}
